// src/config/relicVault/guilds.js
//
// The 9 QuikLearn guilds, the 6 relic rarity tiers, and the flavor text shown
// for owned vs. undiscovered relics. Ported from the designer's handoff
// (relic-vault-react src/data/guilds.ts).
//
// Guild art is looked up by id from images/RelicVault (GUILD_HEADSHOTS,
// COMPANION_ART) rather than stored as paths here.
//
// Not ported: the designer's per-guild `ownedByTier` counts. His README marks
// them as demo seed data that pre-discovers part of the vault so the mockup
// isn't empty; real players start with nothing owned.

export const GUILD_DEFS = [
  {
    "id": "quik",
    "name": "Quik",
    "title": "Progression Guild",
    "color": "#3A7D2C",
    "adjectives": [
      "Explorer's",
      "Wandering",
      "Trailblazing",
      "Bold",
      "Adventurous",
      "Pathfinder's",
      "Daring",
      "Journeying",
      "Steadfast",
      "Curious"
    ]
  },
  {
    "id": "ember",
    "name": "Ember",
    "title": "Flame Guild",
    "color": "#E8563C",
    "adjectives": [
      "Blazing",
      "Smoldering",
      "Infernal",
      "Sunfire",
      "Molten",
      "Radiant",
      "Scorching",
      "Wildfire",
      "Ember-Kissed",
      "Phoenix"
    ]
  },
  {
    "id": "echo",
    "name": "Echo",
    "title": "Secret Society",
    "color": "#4A5FD9",
    "adjectives": [
      "Whispering",
      "Hidden",
      "Silent",
      "Veiled",
      "Mysterious",
      "Shadowed",
      "Murmuring",
      "Enigmatic",
      "Midnight",
      "Echoing"
    ]
  },
  {
    "id": "holly",
    "name": "Holly",
    "title": "Festival Guild",
    "color": "#E85D97",
    "adjectives": [
      "Blooming",
      "Joyful",
      "Festival",
      "Blossom",
      "Cheerful",
      "Radiant",
      "Gentle",
      "Harmony's",
      "Garden",
      "Kindred"
    ]
  },
  {
    "id": "atlas",
    "name": "Atlas",
    "title": "Victory Guild",
    "color": "#2A4E8C",
    "adjectives": [
      "Ancient",
      "Steadfast",
      "Unbreakable",
      "Champion's",
      "Mighty",
      "Enduring",
      "Titan's",
      "Resolute",
      "Ironclad",
      "Victorious"
    ]
  },
  {
    "id": "astra",
    "name": "Astra",
    "title": "Mastery Guild",
    "color": "#8B5CF6",
    "adjectives": [
      "Celestial",
      "Starlit",
      "Astral",
      "Cosmic",
      "Mystic",
      "Lunar",
      "Stellar",
      "Arcane",
      "Nebula",
      "Ethereal"
    ]
  },
  {
    "id": "newton",
    "name": "Newton",
    "title": "Perseverance Guild",
    "color": "#3E8C6E",
    "adjectives": [
      "Clockwork",
      "Ingenious",
      "Tinkerer's",
      "Inventive",
      "Precision",
      "Logical",
      "Mechanized",
      "Analytical",
      "Persistent",
      "Brilliant"
    ]
  },
  {
    "id": "nova",
    "name": "Nova",
    "title": "Inventor Guild",
    "color": "#9D6CFF",
    "adjectives": [
      "Quantum",
      "Radiant",
      "Electric",
      "Nova-Charged",
      "Photon",
      "Circuit",
      "Hyperdrive",
      "Digital",
      "Prism",
      "Inventive"
    ]
  },
  {
    "id": "ace",
    "name": "Ace",
    "title": "Scholar's Guild",
    "color": "#6B9E3F",
    "adjectives": [
      "Scholar's",
      "Wise",
      "Lantern-Lit",
      "Studious",
      "Insightful",
      "Enlightened",
      "Bookish",
      "Sage",
      "Learned",
      "Diligent"
    ]
  }
];

/** Rarity tiers in display order. `count` is relics per tier, per guild. */
export const TIERS = [
  {
    "key": "common",
    "label": "Common",
    "color": "#4ADE80",
    "count": 28
  },
  {
    "key": "uncommon",
    "label": "Uncommon",
    "color": "#38BDF8",
    "count": 18
  },
  {
    "key": "rare",
    "label": "Rare",
    "color": "#A78BFA",
    "count": 13
  },
  {
    "key": "epic",
    "label": "Epic",
    "color": "#EF4444",
    "count": 8
  },
  {
    "key": "legendary",
    "label": "Legendary",
    "color": "#FBBF24",
    "count": 6
  },
  {
    "key": "mythic",
    "label": "Mythic",
    "color": "#F472B6",
    "count": 2
  }
];

/** Flavor text for the relic detail view. */
export const RELIC_DESCRIPTIONS = {
  "owned": "A treasured relic from the {guild}, earned through dedication and discovery.",
  "lockedLow": "Keep exploring to discover this relic.",
  "lockedEpic": "A rare find — few have uncovered this relic's secrets.",
  "lockedLegendary": "Whispers speak of this legendary relic. Keep pushing forward to reveal it.",
  "lockedMythic": "A legendary secret awaits the most dedicated collectors."
};
